module.exports = __webpack_public_path__ + "media/src/assets/images/lps-vs_graph_sp-30ec78eafda92d0f779cf22a30ed2f2c.png";